import { ChevronLeft, ChevronRight } from "lucide-react";

export function usePageSlice(list, page, perPage) {
  const total = Math.max(1, Math.ceil(list.length / perPage));
  const safe = Math.min(page, total);
  const start = (safe - 1) * perPage;
  return { paged: list.slice(start, start + perPage), totalPages: total, start };
}

export const Pagination = ({ page, totalPages, onChange }) => {
  if (totalPages <= 1) return null;
  const pages = Array.from({ length: totalPages }, (_, i) => i + 1);
  return (
    <div className="flex items-center justify-center gap-1.5 mt-6" data-testid="pagination">
      <button onClick={() => onChange(Math.max(1, page - 1))} disabled={page === 1} className="w-9 h-9 rounded-lg border border-border flex items-center justify-center disabled:opacity-40 hover:border-primary" data-testid="page-prev"><ChevronLeft className="w-4 h-4" /></button>
      {pages.map((p) => (
        <button key={p} onClick={() => onChange(p)} className={`min-w-9 h-9 px-2 rounded-lg text-sm border transition-colors ${p === page ? "bg-primary text-primary-foreground border-primary" : "border-border hover:border-primary"}`} data-testid={`page-${p}`}>{p}</button>
      ))}
      <button onClick={() => onChange(Math.min(totalPages, page + 1))} disabled={page === totalPages} className="w-9 h-9 rounded-lg border border-border flex items-center justify-center disabled:opacity-40 hover:border-primary" data-testid="page-next"><ChevronRight className="w-4 h-4" /></button>
    </div>
  );
};
